import React, { useState, useEffect } from 'react';
import { isMockModeEnabled, toggleMockMode } from '../services/apiServiceFactory';

interface MockDataToggleProps {
  className?: string;
}

export function MockDataToggle({ className = '' }: MockDataToggleProps) {
  const [isMockMode, setIsMockMode] = useState<boolean>(false);

  // Initialize state from localStorage on component mount
  useEffect(() => {
    setIsMockMode(isMockModeEnabled());
  }, []);

  const handleToggle = () => {
    // Safety check: ensure we're not in production
    if (process.env.NODE_ENV === 'production') {
      console.warn('Mock data toggle is disabled in production');
      return;
    }
    
    const newValue = toggleMockMode();
    setIsMockMode(newValue);
    
    // Reload the page to apply changes
    // This is the simplest way to ensure all components use the new data source
    window.location.reload();
  };

  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex items-center">
        <button
          onClick={handleToggle}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${
            isMockMode 
              ? 'bg-[#A3C1DA] focus:ring-[#A3C1DA]' 
              : 'bg-gray-200 focus:ring-gray-400'
          }`}
          role="switch"
          aria-checked={isMockMode}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              isMockMode ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
        <span className="ml-3 text-sm font-medium text-gray-700">
          {isMockMode ? 'Använder mockdata (100 stiftelser)' : 'Använder riktigt API'}
        </span>
      </div>
    </div>
  );
}
